import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { IPrescription, IPrescriptionItem } from '../../opd/prescription/iprescription';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PrescriptionTemplateService } from './prescription-template.service';
import { take } from 'rxjs';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-prescription-template',
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    TablerIconsModule,
    ReactiveFormsModule
  ],
  templateUrl: './prescription-template.component.html',
  styleUrl: './prescription-template.component.scss'
})
export class PrescriptionTemplateComponent implements OnInit {

  templateForm: FormGroup;
  prescriptionItemsDetails: IPrescriptionItem[] = [];

  constructor(
    private _formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<PrescriptionTemplateComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: { prescriptionItems: IPrescription, isTemplateApplied: boolean },
    private _prescriptionTemplateService: PrescriptionTemplateService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private translationUtils: TranslationUtils
  ) {
    // Create a deep copy to avoid mutating the original array
    this.prescriptionItemsDetails = _data.prescriptionItems.prescriptionItems.map(item => ({ ...item }));
  }

  ngOnInit(): void {
    this.templateForm = this._formBuilder.group({
      name: ['', [Validators.required, Validators.maxLength(100)]],
      description: ['', Validators.maxLength(255)],
      doctorId: [this._data.prescriptionItems.doctorId]
    });
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  onSaveTemplate() {
    if (!this.templateForm.valid) {
      this.templateForm.markAllAsTouched();
      return;
    }
    const templateData = this.templateForm.value;
    const prescriptionItemsDetails = this.prescriptionItemsDetails;

    const payload = {
      ...templateData,
      prescriptionTemplateDetails: prescriptionItemsDetails.map(x => ({
        drugId: x.drugId,
        dosePattern: x.dosePattern,
        duration: x.duration,
        route: x.route,
        indication: x.indication,
        mealRelation: x.mealRelation,
        instruction: x.instruction
      }))
    };

    this._prescriptionTemplateService.createPrescriptionTemplate(payload).pipe(take(1))
      .subscribe((response) => {
        if (response.isSuccess) {
          this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant('ENTITY.PRESCRIPTION_TEMPLATE')));
          this.dialogRef.close(response);
        } else {
          const allErrors = Object.values(response.errors).flat();
          this.toastr.error(allErrors.join("\n"));
        }
      });
  }

}
